<template>
  <n-layout>
    <n-text-model class="span-6" color="accent" size="xl" weight="regular">
      {{ $t('bookRideOverview.downloadAppTitle') }}
    </n-text-model>

    <n-text block preset="body" white-space="pre-line" color="grey-dark">
      {{ $t('bookRideOverview.downloadAppDescription') }}
    </n-text>

    <div class="span-6 store-links">
      <store-link store="google" />
      <store-link store="apple" />
    </div>
  </n-layout>
</template>

<script>
import StoreLink from '@/components/shared/links/storeLink';

export default {
  components: {
    StoreLink,
  },
};
</script>

<style lang="scss" scoped>
.store-links {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 1.5rem;
  gap: 0.75rem;
  max-width: 100%;
}
</style>